module.exports = __webpack_public_path__ + "img/51-Chêne Clair.jpg";